import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoFormato, TipoFormatoProps } from '../../interfaces/catalogos/TipoFormatoInterface';

export const TipoFormato = () => {

    return new Promise<TipoFormatoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoFormato/', token)
            .then( ({ data } : { data : TipoFormatoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoFormato = () => {

    return new Promise<TipoFormatoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoFormato/ObtenerTipoFormato', token)
            .then( ({ data } : { data : TipoFormatoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoFormato = ( params: TipoFormatoProps ) => {

    return new Promise<TipoFormatoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoFormato/Actualizar', params, token)
            .then( ({ data } : { data : TipoFormatoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoFormato });
            });

        }

    });

}

export const AgregarTipoFormato = ( params: TipoFormatoProps ) => {

    return new Promise<TipoFormatoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoFormato/Agregar', params, token)
            .then( ({ data } : { data : TipoFormatoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoFormato });
            });

        }

    });

}
